<div class="qr-scanner-container" >
    <p-button class="qr-scanner-close-button" icon="pi pi-times" [text]="true" (click)="closeCameraHandler()" />
    <zxing-scanner #scanner (scanSuccess)="qrCodeCapturedHandler($event)"></zxing-scanner>
</div>